import React from 'react'
import PropTypes from 'prop-types'
import {
  Form,
  FormInput,
  FormButton,
  Margin,
  Text,
  Col,
  Row,
} from 'shared/components'
import { Label } from 'shared/components/newInput/Label'

import * as styles from './styles'

const UserFormComponent = ({
  form,
  onSubmitForm,
  loadJurisdictions,
  getOptionLabel,
  getOptionValue,
}) => (
  <Form form={form} onSubmit={onSubmitForm} css={styles.smallerLabels}>
    <Margin bottom={2}>
      <Text as="label" size={11} bold white>
        Required Information:
      </Text>
    </Margin>

    <Margin tb={2}>
      <FormInput
        required
        name="nickName"
        label="Nickname"
        placeholder="johndoe"
        error={form.errors?.nickName}
      />
    </Margin>

    <Margin bottom={1}>
      <FormInput
        required
        name="email"
        label="Email"
        type="email"
        placeholder="Enter your email"
        error={form.errors?.email}
      />
    </Margin>

    <Margin tb={2}>
      <FormInput
        required
        autoComplete="new-password"
        name="password"
        label="Password"
        type="password"
        placeholder="Enter your password"
        error={form.errors?.password}
      />
    </Margin>

    <Margin tb={2}>
      <FormInput
        required
        name="confirmation"
        label="Confirm Password"
        type="password"
        placeholder="Enter your password"
        error={form.errors?.confirmation}
      />
    </Margin>

    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <FormInput
            required
            name="firstName"
            label="First Name"
            placeholder="Enter your First Name"
          />
        </Col>
        <Col xs={6}>
          <FormInput
            required
            name="lastName"
            label="Last Name"
            placeholder="Enter your Last Name"
          />
        </Col>
      </Row>
    </Margin>

    <Margin bottom={2} top={4}>
      <Text as="label" size={11} bold white>
        Additional Information:
      </Text>
    </Margin>

    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <Label label="Country" />
          <FormInput
            oldInput
            cacheOptions
            defaultOptions
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="country"
            placeholder="Select country"
            loadOptions={loadJurisdictions}
            bordered
          />
        </Col>
        <Col xs={6}>
          <FormInput
            name="zip"
            label="Postal Code/ZIP Code"
            placeholder="Postal or ZIP code"
          />
        </Col>
      </Row>
    </Margin>

    <Margin tb={1}>
      <Row>
        <Col xs={6}>
          <FormInput
            label="State/Province/Region"
            name="state"
            placeholder="Name of the state etc."
          />
        </Col>
        <Col xs={6}>
          <FormInput
            label="City/Town"
            name="city"
            placeholder="Name of the city or town"
          />
        </Col>
      </Row>
    </Margin>

    <Margin tb={1}>
      <FormInput
        label="Address Line 1"
        name="address1"
        placeholder="Street number and name (e.g., 123 Main St)"
      />
    </Margin>

    <Margin tb={1}>
      <FormInput
        label="Address Line 2"
        name="address2"
        placeholder="Apartment, suite, unit, building, floor"
      />
    </Margin>

    <Margin top={2} css={styles.buttonContainer}>
      <Text size={11} italic css={styles.requiredFieldsNote}>
        * Required fields
      </Text>
      <FormButton
        submit
        size="large"
        css={[styles.signupButton, { marginLeft: '8px' }]}
      >
        <Text size={11} upper bold black>
          Sign Up
        </Text>
      </FormButton>
    </Margin>
  </Form>
)

UserFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  loadJurisdictions: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
}

export default UserFormComponent
